import { useState } from 'react';

import { Box, Button, Label, ListRow } from '@betterment/samba-react';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { PurposeIconSelector } from '../../Shared/components-v2/purpose-icon-selector/PurposeIconSelector';

import type { ThemedAsset } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

type ImageSelectorProps = {
  themedAsset: ThemedAsset;
  alt: string;
};

export const ImageSelector: React.FC<ImageSelectorProps> = ({ themedAsset, alt }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box>
      <Label>Goal image</Label>
      {isExpanded ? (
        <PurposeIconSelector />
      ) : (
        <ListRow css={{ p: 0 }}>
          <ListRow.LeadingAsset css={{ w: 'size.450', h: 'size.450' }}>
            <ThemedImage themedAsset={themedAsset} alt={alt} />
          </ListRow.LeadingAsset>
          <ListRow.LeadingContent>
            <Button onClick={() => setIsExpanded(true)} variant="ghostPrimary">
              Change or upload image
            </Button>
          </ListRow.LeadingContent>
        </ListRow>
      )}
    </Box>
  );
};
